export default __webpack_public_path__ + "static/media/step1.90bb30e2.svg";